import React, { useEffect, useState } from 'react'
import style from './cardProjectManagerSmall.module.scss'
import { IProjectManager, ITmpProjectManager } from '../../starter/model/interfaces'
import PersonContactSet from '../PersonContactSet/PersonContactSet'
import { EditOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { store } from '../../starter/redux/store'
import { useActions } from '../../starter/hooks/actions'
import { useDeleteProjectManagerMutation, useUpdateProjectManagerMutation } from '../../starter/api/projectManagersApi'
import CardEmployeeTooltip from '../CardEmployeeSmall/CardEmployeeTooltip'
import dayjs from 'dayjs'
import { DATE_FORMAT } from '../../starter/constants'
import { BirthDay } from '../../images/icons'
import CreateProjectManager from '../CreateProjectManager/CreateProjectManager'

type TCardProjectManager = {
  manager: IProjectManager
}
export default function CardProjectManagerSmall({ manager }: TCardProjectManager) {
  const [
    updateProjectManager,
    { isSuccess: isSuccessUpdateProjectManager, isError: isErrorUpdate, error: updateError }
  ] = useUpdateProjectManagerMutation()
  const [
    deleteProjectManager,
    { isLoading: deleteIsLoading, isSuccess: isSuccessDelete, isError: isErrorDelete, error: deleteError }
  ] = useDeleteProjectManagerMutation()
  const { setError, setButtonSet, setTmpProjectManager, onShowModal, setModalData } = useActions()
  const [isBirthday, setIsBirthday] = useState<boolean>(false)
  const [birthday, setBirthday] = useState<string>('')

  useEffect(() => {
    if (isErrorUpdate || isErrorDelete) {
      setError({
        isError: true,
        // @ts-ignore
        message: (updateError && updateError.data) || (deleteError && deleteError.data)
      })
    }
  }, [isErrorUpdate, isErrorDelete, updateError, deleteError])

  useEffect(() => {
    if (isSuccessUpdateProjectManager || isSuccessDelete) {
      onShowModal(false)
    }
  }, [isSuccessUpdateProjectManager, isSuccessDelete])

  useEffect(() => {
    const birthDay = dayjs(manager.birthDay)
    const day = birthDay.get('date')
    const month = birthDay.get('month')
    const year = dayjs().get('year')
    const tmpDate = dayjs(`${year}-${month + 1}-${day}`).format(DATE_FORMAT)
    const diff = dayjs(tmpDate).diff(dayjs(), 'days')
    if (diff <= 14 && diff >= 0) {
      setIsBirthday(true)
      setBirthday(`${month + 1 > 9 ? month + 1 : `0${month + 1}`}-${day > 9 ? day : `0${day}`}`)
    }
  }, [manager])

  const editEmployee = () => {
    onShowModal(true)
    const tmpManager = { ...(manager as ITmpProjectManager) }
    tmpManager.validate = {
      isValid: false,
      showError: false,
      message: []
    }
    setTmpProjectManager(tmpManager)
    setButtonSet([
      {
        type: 'primary',
        loading: deleteIsLoading,
        danger: true,
        confirm: {
          text: 'Удалить проектного менеджера',
          description: `Вы уверены, что хотите удалить проектного менеджера: ${manager.firstName} ${manager.lastName}`,
          onConfirm: () => {
            const { projectManager } = { ...store.getState().tmp }
            if (projectManager) {
              deleteProjectManager(projectManager._id)
            }
          }
        },
        children: 'Удалить'
      },
      {
        type: 'primary',
        onClick: () => {
          const { projectManager } = { ...store.getState().tmp }
          if (projectManager) {
            updateProjectManager(projectManager)
          }
        },
        children: 'Ok'
      },
      {
        onClick: () => onShowModal(false),
        children: 'Cancel'
      }
    ])
    setModalData({
      title: 'Введите данные проекта',
      content: <CreateProjectManager />
    })
  }
  return (
    <div className={style.wrapper}>
      {isBirthday && (
        <div className={style.birthday}>
          <div className={style.birthdayDate}>{birthday}</div>
          <div className={style.birthdayIcon}>
            <BirthDay />
          </div>
        </div>
      )}
      <div className={style.title}>
        <Tooltip
          overlayInnerStyle={{ width: '35rem' }}
          title={() => <CardEmployeeTooltip employee={manager} />}
          trigger={'click'}>
          <div>
            {manager.firstName} {manager.lastName}
          </div>
        </Tooltip>
        <EditOutlined
          style={{ cursor: 'pointer' }}
          onClick={() => {
            editEmployee()
          }}
        />
      </div>
      <PersonContactSet person={manager} />
    </div>
  )
}
